<template>
    <div>

        <h2 class="title">DIALOGUE</h2>

        <form @submit.prevent="validate" @input="saveIt">

            <h2 class="is-size-5">Qui parle ?</h2>
                <b-select v-model="config.data.label" @change.native="updateLocuteur" placeholder="Choisissez" icon="account">
                    <optgroup label="PNJ">
                        <option v-for="(value) in pnjList" :key="value.slug" :value="value.id">{{value.nom}}</option>
                    </optgroup>

                    <optgroup label="MONSTRE">
                        <option v-for="(value) in badList" :key="value.slug" :value="value.id">{{value.nom}}</option>
                    </optgroup>

                    <optgroup label="AUTRES">
                        <option v-for="(value) in otherList" :key="value.slug" :value="value.id">{{value.nom}}</option>
                    </optgroup>
                </b-select>


            <h2 class="is-size-5">Réplique :</h2>
            <b-input  type="textarea" v-model="config.data.description" ref="startFocus" has-counter></b-input>

            <h2 class="is-size-5">Générateur :</h2>
            <b-button
                    size="is-small"
                    type="is-info"
                    class="generator"
                    @click="GenerateDialogue(1,true,1,0,false,false,false)">
                Plus un
            </b-button>
            <b-button
                size="is-small"
                type="is-info"
                class="generator"
                @click="GenerateDialogue(2,false,1,1,true,true,false)">
            Oui-Non
        </b-button>

            <b-button
                    size="is-small"
                    type="is-info"
                    class="generator"
                    @click="GenerateDialogue(2,false,1,1,true,true,true)">
                Oui-Non Essaye encore
            </b-button>
            <b-button
                    size="is-small"
                    type="is-info"
                    class="generator"
                    @click="GenerateDialogue(2,true,1,1,true,true,false)">
                Oui-Non valorisé
            </b-button>
            <b-button
                    size="is-small"
                    type="is-info"
                    class="generator"
                    @click="GenerateDialogue(2,true,1,1,true,false,false)">
                Oui-Non Gratifié
            </b-button>
            <b-button
                    size="is-small"
                    type="is-info"
                    class="generator"
                    @click="GenerateDialogue(2,true,1,1,false,true,false)">
                Oui-Non Reprimandé
            </b-button>
            <b-button
                    size="is-small"
                    type="is-info"
                    class="generator"
                    @click="GenerateDialogue(3,true,1,1,true,true,false)">
                Oui-Non-Neutre valorisé
            </b-button>
            <b-button
                    size="is-small"
                    type="is-info"
                    class="generator"
                    @click="GenerateDialogue(3,true,1,1,true,true,true)">
                Oui-Non-Neutre valorisé essaye encore
            </b-button>
            <hr>
            <h2 class="is-size-5">REQUIS :</h2>

            <carac v-for="(value,key,index) in getReq"
                   :key="value.clef" :objet="value" letype="REQ" :lieu="config.id"
                   @deleteMe="delReq" @reloadMe="reloadMe"></carac>

            <b-collapse :open="false" aria-id="contentIdForA11y1" ref="addrequis" @open="focusReqOn"  @close="focusReqOff">
                <b-button
                        size="is-small"
                        type="is-info"
                        slot="trigger"
                        aria-controls="contentIdForA11y1">
                    <b-icon  icon="plus"></b-icon>
                </b-button>
                <div>
                    <Addcarac :lieu="config.id" @validated="addReq" :open="reqIsOpen" letype="REQ"></Addcarac>
                </div>
            </b-collapse>
        </form>
    </div>
</template>

<script>

    import _ from 'lodash';
    import Addcarac from './AddCarac.vue';
    import Carac from './Carac.vue';

    import ResultatClass from '../../classes/Resultat';
    import TacheClass from '../../classes/Tache';
    import Lien from '../../classes/Lien'

    export default {
        name: 'tabtache',
        data (){
            return {
                reqIsOpen:false,

                isDialogue:false
            }
        },
        components: {
            Carac,
            Addcarac
        },
        props: ['config'],
        computed: {
            getReq(){
                return this.config.requis
            },
            canBeDialogue(){
                return !this.isDialogue
            },

            pnjList(){
                return this.$store.getters.getElementType('PNJ')
            },
            badList(){
                return this.$store.getters.getElementType('BAD')
            },
            otherList(){
                const obj=this.$store.getters.getElementType('OBJ')
                const dec=this.$store.getters.getElementType('DEC')
                return dec.concat(obj)
            },

        },
        watch:{
        },
        methods: {


            saveIt: _.debounce(function (){
                this.validate()
            }, 1000),


            async validate()
            {
                this.$notification.open('SAUVEGARDE!!')

                await this.$store.dispatch('upTask',this.config)
            },

            async reloadMe(){
                // ya un truc qui a changé ailleur, te casse pas, reload le resultat
                const newVersion=await this.$mydb.do.getTask(this.config.id)

                //scrountch
                this.config.data=newVersion.data
            },

            async deleteTache(){
                try {

                    await this.$store.dispatch('delTask',this.config.id)

                    //switch sidebar
                    const toEdit={
                        name:'TabHelp',
                        config:''
                    }
                    this.$store.commit('DROITE_SET',toEdit);
                }
                catch(e) {
                    console.log("Erreur:" + e)
                }
            },

            async addReq(carac){
                const done=await this.$mydb.do.saveCarac(carac)

                //clef unique donc gestion d'une erreur de promesse rejettée
                if(done){
                    this.config.requis.push(carac.clef)
                }
                else {
                    this.alertCustomError("ERREUR ! <br>Cette clef existe déjà pour cet élément précis...")
                }
                this.$refs.addrequis.toggle()
            },
            delReq(evt){
                this.config.requis=this.config.requis.filter( thing => (thing !== evt ))
                this.saveIt()

            },




            async GenerateDialogue(nbRep,finUnique, nbBonne,nbMauvaise,gratification,reprimande,essayeEncore){
                    // const nbRep=5
                    // const nbBonne=2
                    // const nbMauvaise=2
                    // const gratification=true
                    // const reprimande=true
                    // const essayeEncore=true

                    console.log("START GENERATION FROM "+this.config.id)


                    let myFinal=''
                    let myGrat=''
                    let myRepr=''

                    let DISTANCE=400
                    if(gratification || reprimande)
                        DISTANCE=600

                    // GENERATION DES SORTIE
                    //1 faire la destination finale

                    if(finUnique) {
                        const posFinal = {
                            x: this.config.position.x,
                            y: this.config.position.y + DISTANCE
                        }
                        myFinal = new TacheClass(this.config.data.label, this.config.level,this.config.parent, 'DIAL', posFinal)
                        //Sauvegarde tout
                        await this.$mydb.do.saveTask(myFinal);
                        console.log("CREATION FINALE")
                        this.$store.commit('TASK_CREATE', myFinal)
                    }

                    //1.1 SI GRATIFICATION
                    if(gratification){
                        const posGrat={
                            x:this.config.position.x-300,
                            y:this.config.position.y+DISTANCE/2}
                        myGrat=new TacheClass(this.config.data.label,this.config.level,this.config.parent,'DIAL',posGrat)
                        myGrat.id=myGrat.id+'G' //Fix unique key
                        let myRes=new ResultatClass(myGrat.id,true)
                        myRes.type="DIAL"
                        myRes.data.label='Continuer'
                        myRes.data.color=this.$store.getters.getColorUsed[0]
                        myRes.id=myRes.id+'Grat'

                        //CREATION DU LIEN VERS FINAL
                        if(finUnique) {
                            let lien = new Lien(myGrat.id, myRes.id, myFinal.id)

                            lien.points = [myGrat.position.x, myGrat.position.y, myFinal.position.x, myFinal.position.y]
                            lien.data.color = myRes.data.color
                            lien.data.label = myRes.data.label
                            lien.data.ref = lien.data.ref + 'G'  // fix pour reference unique
                            await this.$mydb.do.createLink(lien)
                        }

                        //Sauvegarde tout
                        await this.$mydb.do.saveTask(myGrat);
                        await this.$mydb.do.saveResultat(myRes);
                        console.log("CREATION GRATIFIC")
                        this.$store.commit('TASK_CREATE',myGrat)
                    }

                    //1.2 SI REPRIMANDE
                    if(reprimande){
                        const posRepr={
                            x:this.config.position.x+300,
                            y:this.config.position.y+DISTANCE/2}
                        myRepr=new TacheClass(this.config.data.label,this.config.level,this.config.parent,'DIAL',posRepr)
                        myRepr.id=myRepr.id+'R' //Fix unique key
                        let myRes=new ResultatClass(myRepr.id,true)
                        myRes.type="DIAL"
                        myRes.data.label='Continuer'
                        myRes.id=myRes.id+'Rep'
                        myRes.data.color=this.$store.getters.getColorUsed[0]

                        //CREATION DU LIEN VERS FINAL OU SOURCE SI "ESSAYE-ENCORE" donc uniquement sur les réprimandes
                        let dstID=''
                        let dstX=''
                        let dstY=''

                        if(finUnique)
                        {
                            dstID=myFinal.id
                            dstX=myFinal.position.x
                            dstY=myFinal.position.y
                        }

                        if(reprimande && essayeEncore){
                            dstID=this.config.id
                            dstX=this.config.position.x
                            dstY=this.config.position.y
                            myRes.data.label='Réessayer'
                        }

                        if(finUnique || essayeEncore) {
                            let lien = new Lien(myRepr.id, myRes.id, dstID)

                            lien.points = [myRepr.position.x, myRepr.position.y, dstX, dstY]
                            lien.data.color = myRes.data.color
                            lien.data.label = myRes.data.label
                            lien.data.ref = lien.data.ref + 'R'  // fix pour reference unique
                            await this.$mydb.do.createLink(lien)
                        }

                        //Sauvegarde tout
                        await this.$mydb.do.saveTask(myRepr);
                        await this.$mydb.do.saveResultat(myRes);
                        console.log("CREATION REPRI")
                        this.$store.commit('TASK_CREATE',myRepr)
                    }


                    //2 faire les sorties

                    //Delete des sortie existante
                    await this.$mydb.do.deleteResultatOutOf(this.config.id)

                    // creation des sortie + liens
                     for (let i = 0; i < nbRep; i++){
                         let myRes=new ResultatClass(this.config.id,false)
                         myRes.type="DIAL"
                         myRes.data.label=' #'+i
                         myRes.id=myRes.id+i // fix pour reference unique
                         if(i<nbBonne)
                             myRes.data.color=this.$store.getters.getColorUsed[0]

                         if(i>=nbBonne && i<(nbBonne+nbMauvaise))
                             myRes.data.color=this.$store.getters.getColorUsed[1]

                         await this.$mydb.do.saveResultat(myRes);

                         //destination selon les cas
                         let dstID=''
                         let dstX=''
                         let dstY=''

                         if(finUnique)
                         {
                             dstID=myFinal.id
                             dstX=myFinal.position.x
                             dstY=myFinal.position.y
                         }

                         if(i<nbBonne && gratification){
                             dstID=myGrat.id
                             dstX=myGrat.position.x
                             dstY=myGrat.position.y
                         }

                         if((i>=nbBonne && i<(nbBonne+nbMauvaise)) && reprimande){
                             dstID=myRepr.id
                             dstX=myRepr.position.x
                             dstY=myRepr.position.y
                         }

                         let lien= new Lien( this.config.id,myRes.id,dstID)

                          lien.points=[this.config.position.x,this.config.position.y,dstX,dstY]
                          lien.data.color=myRes.data.color
                          lien.data.label=myRes.data.label
                          lien.data.ref=lien.data.ref+i  // fix pour reference unique

                         await this.$mydb.do.createLink(lien)
                     }

                    // TASK UPDATE
                const mySrc=await this.$mydb.do.getTask(this.config.id)
                this.$store.commit('TASK_UPDATE',mySrc)

                console.log("FIN... UPDATE DES LINK : "+this.config.id)
                this.$store.commit('UPDATE_TASK_LINK',this.config.id)
            },

            async genereTache(tab){

                for (const task in tab){
                    let myTask=new TacheClass(this.config.label,this.config.level,this.config.parent,'DIAL',task.position)
                    //creation d'une sortie par defaut
                    let myRes=new ResultatClass(myTask.id,false)
                    myRes.type="DIAL"
                    myRes.data.label=' #1'
                    //Sauvegarde tout et recharge
                    await this.$mydb.do.saveTask(myTask);
                    await this.$mydb.do.saveResultat(myRes);
                }
            },



            /*
            * OUTILS
             */

            updateLocuteur(){
              const elem=this.$store.getters.getElementId(this.config.data.label)
                this.config.data.locuteur=elem[0].slug
            },

            focusReqOn() {
                this.reqIsOpen=true
            },
            focusReqOff() {
                this.reqIsOpen=false
            },
            alertCustomError(msg) {
                this.$dialog.alert({
                    title: 'Error',
                    message: msg,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'alert-circle-outline',
                    iconPack: 'mdi'
                })
            },

        },
        mounted(){
            this.$refs.startFocus.focus()

        }
    }

</script>


<style lang="scss">

    .generator{
        margin:2px !important;
    }
</style>